import React from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import "../../incidentes.css";
import "bootstrap/dist/css/bootstrap.min.css";

const procesos = [
  {
    titulo: "Solicitud de Alta de Colaborador",
    descripcion:
      "En cualquier organización, contar con un proceso " +
      "formalizado de selección, evaluación y contratación de personal " +
      "es fundamental para asegurar que los nuevos colaboradores no solo " +
      "cubran los requisitos técnicos del puesto, sino que también se " +
      "alineen con la cultura, valores y objetivos estratégicos de la empresa.",
    acciones: [
      { label: "Descargar Formato Alta", href: "doc/formato-alta-colaborador-interno-netjer.docx" },
      { label: "Descargar Formato Carta Responsiva", href: "pdf/carta-responsiva-alta.pdf" },
      { label: "Procedimiento", to: "/recursos-humanos/alta-colaborador-procedimiento" },
    ],
  },
  {
    titulo: "Solicitud de Baja de Colaborador",
    descripcion: "Descripción:",
    acciones: [
      { label: "Descargar Formato Baja", href: "doc/formato-baja-colaborador.docx" },
      { label: "Procedimiento", to: "/recursos-humanos/baja-colaborador-procedimiento", disabled: true },
    ],
  },
  {
    titulo: "Solicitud de Uso de la Camioneta",
    descripcion:
      "La camioneta utilitaria representa una herramienta esencial " +
      "para las operaciones diarias, transporte de personal y traslado " +
      "de materiales. Establecer un control riguroso de su " +
      "uso—incluyendo calendario de reservas, bitácora de kilometraje, y " +
      "políticas de mantenimientos—permite optimizar costos, prolongar su " +
      "vida útil y garantizar la seguridad de los colaboradores.",
    acciones: [
      { label: "Descargar Formato Asignación Camioneta", href: "doc/formato-asignacion-camioneta.docx" },
      { label: "Procedimiento", to: "/recursos-humanos/solicitud-camioneta" },
    ],
  },
  {
    titulo: "Incidencias",
    descripcion: "Guía de ingreso de incidencia para nómina",
    acciones: [
      { label: "Procedimiento", to: "/recursos-humanos/incidencias-rh" },
    ],
  },
];

const RecursosHumanos = () => {
  const bucketUrl = process.env.REACT_APP_BUCKET;
  return (
    <>
      <Container fluid className="background-containerr">
        <div className="orgproc-header">
          <h1 className="orgproc-heading">Recursos Humanos</h1>
        </div>
        <div className="orgproc-grid-4col">
          {procesos.map((proceso, index) => (
            <div className="orgproc-card" key={proceso.titulo}>
              <div className="orgproc-card-accent"></div>
              <div className="orgproc-card-body">
                <div className="orgproc-eyebrow">Proceso #{index + 1}</div>
                <div className="orgproc-card-title">{proceso.titulo}</div>
                <p className="orgproc-card-desc">{proceso.descripcion}</p>
                <div className="orgproc-card-actions">
                  {proceso.acciones.map((accion) =>
                    accion.href ? (
                      <a
                        className="orgproc-card-btn"
                        href={`${bucketUrl}/${accion.href}`}
                        download
                        target="_blank"
                        rel="noopener noreferrer"
                        key={accion.href}
                      >
                        {accion.label} →
                      </a>
                    ) : accion.disabled ? (
                      <span
                        className="orgproc-card-btn orgproc-card-btn--disabled"
                        aria-disabled="true"
                        key={accion.to}
                      >
                        {accion.label}
                      </span>
                    ) : (
                      <Link className="orgproc-card-btn" to={accion.to} key={accion.to}>
                        {accion.label} →
                      </Link>
                    )
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </>
  );
};

export default RecursosHumanos;

// https://app.diagrams.net/#G1HJo4V6_lXFNTb4mwHiA1kvTAdCy4tg1F
